import { jsx as c } from "react/jsx-runtime";
import { d as p, e } from "../../vendor-B6xhktLJ.js";
import '../../assets/index5.css';const r = "wYQ1BW_tooltip", s = {
  tooltip: r
}, a = ({ placement: o = "top", children: t }) => /* @__PURE__ */ c(e, { placement: o, className: s.tooltip, children: t }), $ = (o) => p(o);
export {
  a as Tooltip,
  $ as TooltipTrigger
};
//# sourceMappingURL=index.js.map
